import { useCallback } from 'react';
import t from 'common/i18n';
import { Combobox } from '@cld/combobox';
import { POPULAR_CATEGORIES } from '../../data/consts';
import { useSearchParams } from '../../selectors';
import { getSelectedItemByValue } from '../../utils';
import { SectionBox } from './Filters.styles';

export default ({ handleSearch }) => {
  const { slug } = useSearchParams();
  const options = POPULAR_CATEGORIES.map((c) => ({
    label: c.name,
    value: c.slug,
  }));
  const selectedItem = getSelectedItemByValue(slug, options) ?? null;
  const sortChange = useCallback(
    (item) => {
      handleSearch({
        slug: item?.value || null,
      });
    },
    [handleSearch]
  );

  return (
    <SectionBox data-test="categories-section">
      <label>{t('unsplash.filters.categories.label')}</label>
      <Combobox size="md" isClearable={false} isSearchable={false} options={options} value={selectedItem} onChange={sortChange} />
    </SectionBox>
  );
};
